import React, { useEffect } from 'react';
import styles from '@/assets/styles/Alert.module.less';
import Button from './Button';

interface AlertProps {
  message: string;
  description?: string;
  type?: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
  onClose: () => void;
  onConfirm?: () => void;
  confirmText?: string;
  children?: React.ReactNode;
}

const Alert: React.FC<AlertProps> = ({
  message,
  description,
  type = 'info',
  duration = 3000,
  onClose,
  onConfirm,
  confirmText = '确认',
  children,
}) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return (
    <div className={styles.alertOverlay}>
      <div className={`${styles.alert} ${styles[type]}`}>
        <div className={styles.alertContent}>
          <div className={styles.dotContainer}>
            <div className={styles.dot}></div>
            <div>
              <p className={styles.message}>{message}</p>
              {description && <p className={styles.description}>{description}</p>}
            </div>
          </div>

          <div className={styles.buttonGroup}>
            {children || (
              <>
                <Button className="grayButton" onClick={onClose}>
                  关闭
                </Button>
                {onConfirm && (
                  <Button className="primaryButton" onClick={onConfirm}>
                    {confirmText}
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Alert;
